import { useTranslate } from "@refinedev/core";
import dayjs from 'dayjs';

export function generateRandomString(length: number) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export function syntaxHighlight(json: string | any) {
    if (typeof json != 'string') {
         json = JSON.stringify(json, undefined, 2);
    }
    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
        var cls = 'number';
        if (/^"/.test(match)) {
            if (/:$/.test(match)) {
                cls = 'key';
            } else {
                cls = 'string';
            }
        } else if (/true|false/.test(match)) {
            cls = 'boolean';
        } else if (/null/.test(match)) {
            cls = 'null';
        }
        return '<span class="' + cls + '">' + match + '</span>';
    });
}

function useObjectToDescription(data) {
    const translate = useTranslate();
    return Object.keys(data.data)
        .filter((key) => ["form", "createdAt", "updatedAt", "__entity"].includes(key) === false)
        .map((key) => {
            return {
                label: translate(`products.fields.${key}`),
                key: generateRandomString(4),
                children: data.data[key],
            };
        });
}

export function flattenData(data) {
    //console.log("flattenData", data);
    return data.reduce((flat, item) => {
        flat.push(item);
        //console.log("item", item);
        if (item.children && item.children.length > 0) {
            flat.push(...flattenData(item.children));
        }
        return flat;
    }, []);
}


export function dateSorter(a: string, b: string) {
    //console.log("Sorting", dayjs(a).format("DD/MM/YYYY HH:mm"), dayjs(b).format("DD/MM/YYYY HH:mm"));
    const res = dayjs(a).isBefore(dayjs(b));
    //console.log("Sort res", res);
    return res;
}

export function fullName(data) {
    const res = `${data?.firstName} ${data?.lastName}`;
    //console.log("Full Name", res);
    return res;
}

export function concatValues(list, field = null) {
    if (!list) return "";
    if (field) {
        return list.map((item) => item[field]).join(", ");
    }
    return list.map((item) => item.value).join(", ");
}

/**
 * Generate a consistent color for avatars based on entity ID and palette.
 * @param id - The ID of the user/entity
 * @param palette - Theme-derived colors (e.g. from useAvatarPalette())
 */
export function getAvatarColor(id: number, palette: string[]): string {
    if (!palette.length) return "#888888";
    return palette[Math.abs(id) % palette.length];
}

/**
 * Generate initials from user's first and last name
 * @param firstName - User's first name
 * @param lastName - User's last name
 * @returns Initials string (e.g., "JD" for John Doe)
 */
export function getInitials(firstName?: string, lastName?: string): string {
    if (!firstName && !lastName) return "?";
    
    const first = firstName?.charAt(0)?.toUpperCase() || "";
    const last = lastName?.charAt(0)?.toUpperCase() || "";
    
    return (first + last) || "?";
}

/**
 * Generate initials from an entity name (for groups, service providers, etc.)
 * @param name - The name of the entity
 * @returns Initials string (e.g., "ET" for "Engineering Team")
 */
export function getInitialsFromName(name: string): string {
    if (!name) return "?";
    
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
}